export const GradientColorInputTags = [
  { id: '#9FEAFB,#BFF4FF,#FFBAF8', name: 'آبی صورتی' },
  { id: '#C0F2ED,#FFF6E0', name: 'زرد سبز' },
  { id: '#F1F2C0,#CBFFFC', name: 'سبز زرد' },
  { id: '#CFC8F6,#9BD5F5', name: 'بنفش آبی' },
  { id: '#F6D3C8,#F5AC9B', name: 'سفید نارنجی' },
  { id: '#EDF6C8,#FDC1F7', name: 'زرد صورتی' },
  { id: '#E3D9FF,#FDFDFF', name: 'بنفش سفید' },
];

export const GradientColorDecoder ={
  '#9FEAFB,#BFF4FF,#FFBAF8': 'آبی صورتی',
  '#C0F2ED,#FFF6E0': 'زرد سبز',
  '#F1F2C0,#CBFFFC': 'سبز زرد',
  '#CFC8F6,#9BD5F5': 'بنفش آبی',
  '#F6D3C8,#F5AC9B': 'سفید نارنجی',
  '#EDF6C8,#FDC1F7': 'زرد صورتی',
  '#E3D9FF,#FDFDFF': 'بنفش سفید',
    }
;